module.exports = __webpack_public_path__ + "media/images/no-image-5da187217e0087515709c9694398a583.png";